import { useContext, useEffect, useState } from "react";
import InfoCard from "../Atomics/InfoCard/InfoCard";
import {
  faUsers,
  faVideo,
  faListAlt,
  faCloudUploadAlt,
  faHeart,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { infoFetcher } from "../../api/requests";
import { Spinner } from "react-bootstrap";
import { ProfileContext } from "../../context/profile";

export default function InfoCards({ ownerId }) {
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const { profile } = useContext(ProfileContext);

  const getInfo = async () => {
    if (profile.user) {
      try {
        setLoading(true);
        setInfo(await infoFetcher.get(profile?.user));
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getInfo();
  }, [profile?.user]);

  return (
    <div className="infoCards">
      <InfoCard
        name="channel"
        loading={loading}
        label={`${
          info?.count_owned_channels
          // + info?.count_admin_channels
        } کانال`}
        icon={faUsers}
        bg="primary"
      />
      <InfoCard
        ownerId={ownerId}
        name="video"
        loading={loading}
        label={`${
          info?.count_video_in_owned_channel
          // +
          // info?.count_video_published_in_admin_channel
        } ویدئو`}
        icon={faVideo}
        bg="warning"
      />
      <InfoCard
        name="comment"
        loading={loading}
        label={`${
          info?.counted_comments_of_video_in_owned_channel
          // +
          // info?.counted_comments_of_video_published_in_admin_channel
        } نظر`}
        icon={faListAlt}
        bg="success"
      />
      <InfoCard
        name="interaction"
        loading={loading}
        label={`${
          info?.counted_like_of_video_in_owned_channel +
          info?.counted_dislike_of_video_in_owned_channel +
          info?.counted_save_of_video_in_owned_channel +
          info?.counted_share_of_video_in_owned_channel
          // +
          // info?.counted_like_of_video_published_in_admin_channel +
          // info?.counted_dislike_of_video_published_in_admin_channel +
          // info?.counted_save_of_video_published_in_admin_channel +
          // info?.counted_share_of_video_published_in_admin_channel
        } واکنش`}
        icon={faHeart}
        bg="danger"
      />
      <InfoCard
        name="view"
        loading={loading}
        label={`${
          info?.counted_views_of_video_in_owned_channel
          // +
          // info?.counted_views_of_video_published_in_admin_channel
        } بازدید`}
        icon={faEye}
        bg="info"
      />
    </div>
  );
}
